import type { BusinessRead } from '../../types/api';
import { useAccount } from './useAccount';

export interface BusinessResult {
  business: BusinessRead | null;
  /** Ownership root for every knowledge-base and pipeline call (SRS §4). */
  businessId: string | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

/**
 * The active brand, fetched once by `AccountProvider`.
 *
 * An account may hold several brands; `BrandSwitcher` picks which one is
 * active, and every business-scoped hook keys on the id returned here.
 */
export function useBusiness(): BusinessResult {
  const { business, isLoading, error, refresh } = useAccount();
  return { business, businessId: business?.id ?? null, isLoading, error, refresh };
}
